// Need to use the React-specific entry point to import createApi
import { createApi } from "@reduxjs/toolkit/query/react";
import { encryptedBaseQueryWithReauth } from "../utilities/encryptedBaseQuery";

export const dailyStreakApi = createApi({
  reducerPath: "dailyStreakApi",
  baseQuery: encryptedBaseQueryWithReauth(process.env.REACT_APP_LOCAL_URL),

  // baseQuery: encryptedBaseQueryWithReauth(process.env.REACT_APP_LOCAL_URL),
  tagTypes: ["getTaskList"],
  endpoints: (builder) => ({
    getTaskList: builder.query({
      query: (endpoint) => `${endpoint}`,
      providesTags: ["getTaskList"],
    }),

    getList: builder.query({
      query: (endpoint) => `${endpoint}`,

    }),


    getDailyStreakTask: builder.query({
      query: (endpoint) => `${endpoint}`,
      providesTags: ["getDailyStreakTask"],
    }),


    getDailyStreakReward: builder.query({
      query: (endpoint) => `${endpoint}`,
      providesTags: ["getDailyStreakTask"],
    }),

    create: builder.mutation({
      query: ({ endpoint, data }) => {
        return {
          url: endpoint,
          method: "POST",
          body: data,

        };
      },
      invalidatesTags: ["getDailyQuiz"],
    }),

    update: builder.mutation({
      query: ({ endpoint, updatedData }) => {
        return {
          url: endpoint,
          method: "PATCH",
          body: updatedData,

        };
      },
      invalidatesTags: ["getDailyQuiz"],
    }),

    addClassVideo: builder.mutation({
      query: ({ endpoint, data }) => {
        return {
          url: endpoint,
          method: "POST",
          body: data,
        };
      },
    }),
    updateClassVideo: builder.mutation({
      query: ({ endpoint, updatedData }) => {
        return {
          url: endpoint,
          method: "PATCH",
          body: updatedData,
        };
      },
    }),
    classVideoList: builder.query({
      query: (endpoint) => `${endpoint}`,

    }),

    // uploadImage: builder.mutation({
    //   query: ({ endpoint, formData }) => ({
    //     url: endpoint,
    //     method: "POST",
    //     body: formData, // FormData → not encrypted
    //   }),
    // })



    // updateDailyQuiz: builder.mutation({
    //   query: ({ endpoint,updatedData }) => {
    //     return {
    //       url: endpoint,
    //       method: "PATCH",
    //       body: updatedData,

    //     };
    //   },
    //   invalidatesTags: ["getDailyQuiz"],
    // }),




  }),
});

export const {
  useGetDailyStreakRewardQuery,
  useGetDailyStreakTaskQuery,
  useGetTaskListQuery,
  useCreateMutation,
  useAddClassVideoMutation,
  useUpdateClassVideoMutation,
  useGetListQuery,
  useUpdateMutation,
  useClassVideoListQuery,
  // useUploadImageMutation

} = dailyStreakApi;
